<template>
  <div>
    <div v-if="show">
      <GridLoading></GridLoading>
    </div>
    <k-dialog v-if="showPopup" :title="duplicateStyle" @close="toggleDialog">
      <div class="body">
        <label for="tbox1" style="padding-bottom: 6px; font-size: 14px; margin-right: 13rem">{{
          $t("duplicateStylePopup.styleName")
        }}</label>
        <span class="counter">{{ remaningLength }}/30</span>
        <input
          type="text"
          :class="{ errorStyle: errorMsg }"
          maxlength="30"
          id="tbox1"
          style="padding: 2px"
          name="tbox1"
          v-model="value"
          @input="setCounter($event)"
        /><br />
      </div>
      <dialog-actions-bar>
        <kbutton class="save" @click="createDuplicateStyle"
          ><i class="fas fa-file-alt" style="padding-right: 5px"></i>{{ $t("duplicateStylePopup.save&Open") }}</kbutton
        >
        <kbutton class="cancel" @click="toggleDialog"
          ><i class="fas fa-ban" style="padding-right: 5px"></i>{{ $t("duplicateStylePopup.cancel") }}</kbutton
        >
      </dialog-actions-bar>
    </k-dialog>
  </div>
</template>
<script lang="ts">
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { Button } from "@progress/kendo-vue-buttons";
import { StyleApi } from "@/api";
import GridLoading from "./GridLoading.vue";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";

export default defineComponent({
  name: "DuplicateStylePopup",
  components: {
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
    kbutton: Button,
    GridLoading
  },
  props: {
    showPopup: null,
    duplicateStyleId: null
  },
  emits: ["duplicateId", "visibleDialog"],
  setup() {
    const styleApi = new StyleApi();
    return {
      styleApi
    };
  },
  data() {
    return {
      value: "",
      errorMsg: "",
      remaningLength: 0,
      duplicateId: null as any,
      visibleDialog: null as any,
      show: false,
      duplicateStyle: this.$t("duplicateStylePopup.duplicateStyle"),
      toast: useToast()
    };
  },
  methods: {
    toggleDialog(): void {
      this.visibleDialog = this.showPopup;
      this.visibleDialog = false;
      globalThis.location.reload();
    },
    setCounter(event: Event): void {
      const inputValue = (event.target as HTMLInputElement).value;
      this.remaningLength = inputValue.length;
    },
    async createDuplicateStyle(): Promise<void> {
      if (this.value == "" || this.value == null || this.value == undefined)
        this.errorMsg = "Please Enter a Style Name!";
      else {
        await this.styleApi.apiIsDuplicateStyleNameGet(this.value).then(async e => {
          if (e.data) {
            this.errorMsg = "Style with the given name already exist!";
          } else {
            this.errorMsg = "";
            this.show = true;
            try {
              const res = await this.styleApi.apiCloneStylePost(this.duplicateStyleId, this.value);
              if (res) {
                this.duplicateId = res.data;
                this.toast.success("Data Cloned Successfully", {
                  toastClassName: "custom-success-toast",
                  timeout: 5000
                });
              }
            } catch {
              this.toast.error("Error in Cloning", {
                toastClassName: "custom-error-toast",
                timeout: 5000
              });
            } finally {
              this.show = false;
              this.visibleDialog = false;
              this.$emit("duplicateId", this.duplicateId);
              this.$emit("visibleDialog", this.visibleDialog);
              this.value = "";
              this.remaningLength = 0;
            }
          }
        });
      }
      if (this.errorMsg != "") {
        this.toast.error(this.errorMsg, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    }
  }
});
</script>
<style scoped>
.body {
  margin-left: 21px;
  margin-right: 21px;
  margin-bottom: 21px;
  display: grid;
  text-align: center;
  width: 18rem;
  height: 7rem;
}
.save {
  color: #fff;
  background-color: #0054a6;
  border-radius: 5px;
}
.cancel {
  border-radius: 5px;
}
.counter {
  position: absolute;
  top: 80px;
  right: 39px;
}
.errorStyle {
  border-color: red;
}
</style>
